import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  formsBegin,
  formsSuccess,
  formsErr

} = actions;

const getJotFormsAPI = '/admin/get-connected-forms';
const addUserFormsAPI = '/admin/update-user-forms';
const ConnectedUserFormsAPI = '/admin/get-connected-user-forms';
const ConnectedListingFormsAPI  = '/admin/listing-connected-forms';

const getFormsDetails = (values) => {
  return async (dispatch) => {
    dispatch(formsBegin());
    try {
      const response = await DataService.post(getJotFormsAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(formsErr(response?.data?.message));
      } else {
        dispatch(formsSuccess(response?.data?.result));
      }
      return response?.data;
    } catch (err) {
      dispatch(formsErr(err));
    }
  };
};

const saveUserForms = (values) => {
  return async (dispatch) => {
    dispatch(formsBegin());
    try {
      const response = await DataService.post(addUserFormsAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(formsErr(response?.data?.message));
      } else {
        dispatch(formsSuccess(response?.data?.result));
      }
      return response?.data;
    } catch (err) {
      dispatch(formsErr(err));
    }
  };
};

const getConnectedUserForms = (values) => {
  return async (dispatch) => {
    dispatch(formsBegin());
    try {
      const response = await DataService.post(ConnectedUserFormsAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(formsErr(response?.data?.message));
      } else {
        dispatch(formsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(formsErr(err));
    }
  };
};

const checkFormsConnectedToListings = (values) => {
  return async (dispatch) => {
    dispatch(formsBegin());
    try {
      const response = await DataService.post(ConnectedListingFormsAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(formsErr(response?.data?.message));
      } else {
        dispatch(formsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(formsErr(err));
    }
  };
};

export { getFormsDetails, saveUserForms, getConnectedUserForms, checkFormsConnectedToListings };
